import React from 'react';
import { BadgeDollarSign, Clock, Leaf, ShieldCheck } from 'lucide-react';
const FEATURES = [{
  icon: BadgeDollarSign,
  title: 'Clear rental pricing',
  body: 'See both short-term and 7-day rates before you book, with no surprise fees.'
}, {
  icon: Clock,
  title: 'Fast, reliable delivery',
  body: 'Next-day delivery in most areas, with on-time drop-off and pickup you can count on.'
}, {
  icon: ShieldCheck,
  title: 'Licensed & insured',
  body: 'Fully licensed and insured local haulers who treat your property with care.'
}, {
  icon: Leaf,
  title: 'Responsible disposal',
  body: 'We recycle and divert waste from landfills wherever possible.'
}];
const SERVICE_PROMISES = ['Clear rental windows and pricing before you book', 'Delivery availability confirmed for your address', 'A local team you can call with project questions'];
export function WhyUs() {
  return <section id="why-us" className="w-full border-t border-border bg-secondary/40 py-16 md:py-24" data-id="element-354">
      <div className="container" data-id="element-355">
        <div className="mx-auto max-w-2xl text-center" data-id="element-356">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl" data-id="element-357">
            Why choose Greeneway
          </h2>
          <p className="mt-3 text-muted-foreground" data-id="element-358">
            A local team built on fair prices, dependable service, and doing
            right by our neighbors.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-359">
          {FEATURES.map(f => <div key={f.title} className="rounded-xl border border-border bg-card p-6" data-id="element-360">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary" data-id="element-361">
                <f.icon className="h-5 w-5" data-id="element-362" />
              </span>
              <h3 className="mt-4 text-base font-semibold text-card-foreground" data-id="element-363">
                {f.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground" data-id="element-364">{f.body}</p>
            </div>)}
        </div>

        <div className="mt-10 grid gap-4 rounded-xl border border-border bg-card p-6 sm:grid-cols-3" data-id="element-365">
          {SERVICE_PROMISES.map(promise => <p key={promise} className="text-sm text-muted-foreground" data-id="element-366">
              {promise}
            </p>)}
        </div>
      </div>
    </section>;
}